import { createFileRoute } from "@tanstack/react-router";
import { actions } from "../../lib/actions.ts";
import {
  UNDERSTAND_TABS,
  type UnderstandSearch,
  type UnderstandTab,
} from "../../screens/understanding/tabs.ts";
import { UnderstandScreen } from "../../screens/understanding/UnderstandingScreen.tsx";

const KEY = /^[a-z0-9][a-z0-9-]{0,79}$/;

/** `/understanding`: what Adea understands about the business. */
export const Route = createFileRoute("/_app/understanding")({
  validateSearch: (search: Record<string, unknown>): UnderstandSearch => {
    const view =
      search.view === "overview" || UNDERSTAND_TABS.includes(search.view as UnderstandTab)
        ? (search.view as UnderstandTab | "overview")
        : undefined;
    const area =
      view === "areas" && typeof search.area === "string" && KEY.test(search.area) ? search.area : undefined;
    const q = typeof search.q === "string" && search.q.length < 120 ? search.q : undefined;
    const item = typeof search.item === "string" && KEY.test(search.item) ? search.item : undefined;
    return {
      ...(view && view !== "all" ? { view } : {}),
      ...(area ? { area } : {}),
      ...(q ? { q } : {}),
      ...(item ? { item } : {}),
    };
  },
  loader: ({ context }) => context.queryClient.prefetchQuery(actions.queryOptions("understanding.get", {})),
  component: UnderstandScreen,
});
